var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { StateBuildingGraphics } from "../../graphics/StateBuildingGraphics";
import { selectWaterTowerCanCollectWater } from "../../selectors/selectWatertowerInfo";
import { shallowDiffers } from "../../utils/shallowDiffers";
import { OutskirtBuildingWithLevel, } from "../outskirts/OutskirtBuildingWithLevel";
var OutskirtBuildingWatertower = /** @class */ (function (_super) {
    __extends(OutskirtBuildingWatertower, _super);
    function OutskirtBuildingWatertower() {
        var _this = _super.call(this, IdOutskirtBuildings.Watertower) || this;
        _this.shouldUpdate = function (props, prevProps) {
            if (!props.areAssetsLoaded) {
                return false;
            }
            return (!prevProps ||
                shallowDiffers(props.data, prevProps.data) ||
                props.isAccessible !== prevProps.isAccessible ||
                prevProps.areAssetsLoaded !== props.areAssetsLoaded ||
                prevProps.shouldRenderCallout !== props.shouldRenderCallout);
        };
        _this.mapState = function (state) {
            var baseState = _this.baseMapState(state);
            var shouldRenderCallout = selectWaterTowerCanCollectWater(state);
            return __assign({}, baseState, { shouldRenderCallout: shouldRenderCallout });
        };
        _this.update = function (props) {
            _this.baseUpdate(props, StateBuildingGraphics.Idle, true, props.shouldRenderCallout);
        };
        return _this;
    }
    return OutskirtBuildingWatertower;
}(OutskirtBuildingWithLevel));
export { OutskirtBuildingWatertower };



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/OutskirtBuildingWatertower.ts
// module id = 2229
// module chunks = 3